/*
 * File: index.tsx
 * Desc: 间距占位组件
 * File Created: 2019-12-06 15:40:47
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React from 'react';

interface SpacerProps {
    height?: string | number;
    width?: string | number;
    children?: React.ReactElement | null | undefined | any[];
    style?: React.CSSProperties;
}

const Spacer = (props: Partial<React.HTMLAttributes<HTMLDivElement>> & SpacerProps) => {
    return (
        <div
            className={props.className}
            style={{ width: props.width || '100%', height: props.height || '100%', ...props.style }}
        >
            {props.children}
        </div>
    );
};

export default Spacer;
